<div class="container-fluid container-xxl overflow-hidden gx-sm-9 gx-lg-10 gx-xxl-0 overflow-hidden py-6 py-md-12">
    @if ((categories$ | async) === false) {
        <div class="col-md-9">
            <div class="spinner mx-auto"></div>
        </div>
    }
    @if (categories$ | async; as categories) {
        <div class="d-md-flex align-items-center justify-content-center flex-nowrap">
            @if (isPruductsPage) {
                <div class="col-12 col-md-3 mb-5 mb-md-0">
                    <h3 class="mb-xl-4 mb-5 fs-12 fw-700 ls-2 font-secondary text-secondary text-uppercase">
                        {{ 'PRODUCTS.product_categories.title' | translate }}
                    </h3>
                    <p class="lh-29 mb-0">{{ 'PRODUCTS.product_categories.description' | translate }}</p>
                </div>
            }
            <div class="col-12 col-md-9">
                <div class="ms-0 ms-md-7 d-flex align-items-center">
                    <div class="d-none d-lg-block">
                        <div #swiperNavigationPrev class="categories-arrow categories-arrow-left align-self-stretch">
                            <span></span>
                        </div>
                    </div>
                    <div class="categories-list">
                        <div class="d-none d-md-block">
                            <div #swiper class="swiper" [class.is-client]="isClient">
                                <div class="swiper-wrapper">
                                    @for (item of categories; track item.slug) {
                                        <div class="swiper-slide">
                                            <a [id]="item.slug" [routerLink]="link(item.slug) | localize">
                                                <div class="categories-item">
                                                    <img class="w-75 mb-3 mx-auto d-block" [src]="item.image.url" [alt]="item.name" />
                                                    <h5 class="font-secondary text-center text-oneline fw-700 fs-14 mb-0">
                                                        {{ item.name }}
                                                    </h5>
                                                </div>
                                            </a>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="d-md-none">
                            <div class="row">
                                @for (item of categories; track item.slug) {
                                    <div class="col-6 mb-7">
                                        <a [routerLink]="link(item.slug) | localize">
                                            <div>
                                                <img class="w-75 mb-3 mx-auto d-block" [src]="item.image.url" [alt]="item.name" />
                                                <h5 class="font-secondary text-center text-oneline fw-700 fs-14 mb-0">
                                                    {{ item.name }}
                                                </h5>
                                            </div>
                                        </a>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="d-none d-md-block">
                        <div #swiperNavigationNext class="ms-auto categories-arrow categories-arrow-right align-self-stretch">
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
